import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import rules from '@/utils/rules'

import { formatNumber, roundNumber } from '@/utils/number'

export default {
  data: () => ({
    rules,
    fileCodes: {
      ID_CARD: 100,
      KSK_PROOF: 101,
      PROOF_TRAINING: 102,
      PROOF_SELF_EMP: 103,
      PROOF_TAX: 104
    },

    genders: [
      'Frau',
      'Herr',
      'divers'
    ],

    states: [
      {
        id: 'BW',
        text: 'Baden-Württemberg'
      },
      {
        id: 'BY',
        text: 'Bayern'
      },
      {
        id: 'BE',
        text: 'Berlin'
      },
      {
        id: 'BB',
        text: 'Brandenburg'
      },
      {
        id: 'HB',
        text: 'Bremen'
      },
      {
        id: 'HH',
        text: 'Hamburg'
      },
      {
        id: 'HE',
        text: 'Hessen'
      },
      {
        id: 'MV',
        text: 'Mecklenburg-Vorpommern'
      },
      {
        id: 'NI',
        text: 'Niedersachsen'
      },
      {
        id: 'NW',
        text: 'Nordrhein-Westfalen'
      },
      {
        id: 'RP',
        text: 'Rheinland-Pfalz'
      },
      {
        id: 'SL',
        text: 'Saarland'
      },
      {
        id: 'SN',
        text: 'Sachsen'
      },
      {
        id: 'ST',
        text: 'Sachsen-Anhalt'
      },
      {
        id: 'SH',
        text: 'Schleswig-Holstein'
      },
      {
        id: 'TH',
        text: 'Thüringen'
      }
    ],

    starters: [
      {
        text: 'Ich bin selbständig in einer künstlerischen Tätigkeit',
        value: false
      },
      {
        text: 'Ich bin Berufsanfänger mit einer einschlägigen, künstlerischen Ausbildung, bspw. einem abgeschlossenen Studium',
        value: true
      }
    ]
  }),

  computed: {
    ...mapGetters([
      'isDebugMode',
      'disabledUrl',
      'fileError',
      'formData',
      'isFinished',
      'isSignMode',
      'isSigned',
      'inputsToken'
    ]),
  },

  methods: {
    ...mapActions([
      'setFileError',
      'setFormData',
      'setFinished',
      'setSigned',
    ]),

    getStateById (id) {
      const state = this.states.find(s => s.id === id)
      return state ? state.text : ''
    },

    getStarterById (v) {
      const starter = this.starters.find(s => s.value === v)
      return starter ? starter.text : ''
    },

    formatDateTime (value, format = 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]') {
      if (!value) {
        return ''
      }

      const date = moment(value)

      return date.isValid()
        ? date.format(format)
        : null
    },

    formatMoney (value, decimals = 2) {
      const v = roundNumber(value, decimals)

      return `${ formatNumber(v, decimals) }€`
    },

    getDateByOffset (offsetValue, offsetType = 'years') {
      const date = moment().add(offsetValue, offsetType)
      return date.isValid()
        ? date.format('YYYY-MM-DD')
        : undefined
    },

    getElementTop (element) {
      if (!element) {
        return 0
      }

      let top = 0

      do {
        top += element.offsetTop || 0
        element = element.offsetParent
      } while (element)

      return top
    },

    getFirstErrorField (formRef) {
      const form = this.$refs[formRef]
      if (!form || form.validate()) {
        return null
      }

      return form.inputs.find(f => !f.valid)
    },

    gotoRoute (name, params = null) {
      if (!name) {
        return
      }
      const route = {
        name,
      }
      if (params) {
        route.params = params
      }
      this.$router.push(route)
    },

    isFormValid (ref) {
      const form_ = this.$refs[ref]
      return form_ && form_.validate()
    },

    resetForm (ref) {
      const form_ = this.$refs[ref]
      if (form_) {
        form_.resetValidation()
      }
    },

    saveFieldValue (key, value) {
      this.setFormData({
        key,
        value
      })

      if (key === 'kuenstlersozialkasse' && value) {
        this.setFormData({
          key: 'berufsanfaenger',
          value: null
        })

        this.setFormData({
          key: 'datei_berufsanfaenger_ausbildungsnachweis',
          value: null
        })
      } else if (key === 'mit_stipendium') {
        this.setFormData({
          key: 'kein_stipendium',
          value: !value
        })
      } else if (key === 'kein_stipendium') {
        this.setFormData({
          key: 'mit_stipendium',
          value: !value
        })
      }
    }
  }
}
